/* tpl-mat-swap-wipe.js (2026-10-29) · Mat / Framing swap wipe for the La Siesta gallery.
   tpl-mat-pdp.js swaps the gallery picture by setting img.src (data-mg-swap /
   data-mg-variants). This file never touches that logic: it watches the src
   attribute and, on the slide the shopper can see, slides the new picture in
   over the old one like a panel pushed into the frame (clip-path + transform
   only, ~420ms). Reduced motion gets a 120ms crossfade. */
(function () {
  'use strict';
  if (window.tplMatSwapWipe) return;
  window.tplMatSwapWipe = true;

  var DUR = 420;
  var FADE = 120;
  var DECODE_WAIT = 2500;
  var EASE = 'cubic-bezier(0.65, 0, 0.25, 1)';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var shown = new WeakMap(); /* img -> url the shopper is actually looking at */
  var running = new WeakMap(); /* img -> cleanup fn */

  function isGalleryImg(el) {
    return el && el.tagName === 'IMG' && el.classList.contains('tpl-mg__img') && !!el.closest('[data-mg-slide]');
  }

  function remember(img) {
    var u = img.currentSrc || img.getAttribute('src');
    if (u && img.complete && img.naturalWidth) shown.set(img, u);
  }

  function onScreen(slide) {
    var a = slide.getBoundingClientRect();
    if (!a.width || a.bottom <= 0 || a.top >= window.innerHeight) return false;
    var track = slide.closest('[data-mg-track]');
    var b = track ? track.getBoundingClientRect() : { left: 0, right: window.innerWidth };
    var overlap = Math.min(a.right, b.right) - Math.max(a.left, b.left);
    return overlap > a.width * 0.5;
  }

  function waitDecode(img) {
    return new Promise(function (resolve) {
      var done = false;
      var finish = function (ok) {
        if (done) return;
        done = true;
        resolve(ok);
      };
      setTimeout(function () { finish(false); }, DECODE_WAIT);
      if (img.decode) {
        img.decode().then(function () { finish(true); }, function () {
          /* decode() rejects when src changes again mid-flight; fall back to load */
          if (img.complete && img.naturalWidth) finish(true);
        });
      }
      img.addEventListener('load', function () { finish(true); }, { once: true });
      img.addEventListener('error', function () { finish(false); }, { once: true });
    });
  }

  function play(img, oldUrl) {
    var prev = running.get(img);
    if (prev) prev();

    var slide = img.closest('[data-mg-slide]');
    /* A div, not an img: tpl-mat-pdp.js swaps slide.querySelector('img'), so an
       extra <img> placed before the real one would be the one it rewrites. */
    var ghost = document.createElement('div');
    ghost.className = 'tpl-msw__ghost';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.backgroundImage = 'url("' + String(oldUrl).replace(/["\\]/g, '') + '")';
    img.parentNode.insertBefore(ghost, img);

    var edge = null;
    var anims = [];
    var cancelled = false;
    img.classList.add('tpl-msw__new');
    var reduce = calm.matches;
    if (reduce) img.style.opacity = '0';
    else img.style.clipPath = 'inset(0 100% 0 0)';

    function cleanup() {
      cancelled = true;
      anims.forEach(function (a) { try { a.cancel(); } catch (e) { /* noop */ } });
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      if (edge && edge.parentNode) edge.parentNode.removeChild(edge);
      img.classList.remove('tpl-msw__new');
      img.style.clipPath = '';
      img.style.opacity = '';
      running.delete(img);
    }
    running.set(img, cleanup);

    waitDecode(img).then(function (ok) {
      if (cancelled) return;
      if (!ok || !img.animate) { cleanup(); return; }
      var last;
      if (reduce) {
        last = img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FADE, easing: 'linear', fill: 'forwards' });
        anims.push(last);
      } else {
        var w = slide.clientWidth;
        edge = document.createElement('span');
        edge.className = 'tpl-msw__edge';
        edge.setAttribute('aria-hidden', 'true');
        img.parentNode.insertBefore(edge, img.nextSibling);
        last = img.animate(
          [{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }],
          { duration: DUR, easing: EASE, fill: 'forwards' }
        );
        anims.push(last);
        anims.push(edge.animate(
          [
            { transform: 'translate3d(0,0,0)', opacity: 0 },
            { transform: 'translate3d(' + w * 0.12 + 'px,0,0)', opacity: 1, offset: 0.12 },
            { transform: 'translate3d(' + w * 0.88 + 'px,0,0)', opacity: 1, offset: 0.88 },
            { transform: 'translate3d(' + w + 'px,0,0)', opacity: 0 },
          ],
          { duration: DUR, easing: EASE, fill: 'forwards' }
        ));
      }
      last.onfinish = function () {
        if (!cancelled) cleanup();
      };
    });
  }

  function onMutations(records) {
    var seen = new Set();
    records.forEach(function (r) {
      var img = r.target;
      if (r.attributeName !== 'src' || seen.has(img) || !isGalleryImg(img)) return;
      seen.add(img);
      var oldUrl = shown.get(img) || r.oldValue;
      var nextUrl = img.getAttribute('src');
      if (!oldUrl || !nextUrl || oldUrl === nextUrl) return;
      var slide = img.closest('[data-mg-slide]');
      if (!onScreen(slide)) return;
      play(img, oldUrl);
    });
  }

  function init() {
    var gallery = document.querySelector('[data-tpl-mat-gallery]');
    if (!gallery || !window.MutationObserver) return;
    gallery.querySelectorAll('img.tpl-mg__img').forEach(remember);
    gallery.addEventListener('load', function (e) {
      if (isGalleryImg(e.target)) remember(e.target);
    }, true);
    new MutationObserver(onMutations).observe(gallery, {
      subtree: true,
      attributes: true,
      attributeFilter: ['src'],
      attributeOldValue: true,
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
